import React from 'react';
import PropTypes from 'prop-types';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';

import { Banner } from 'core/components/banner';
import { Label } from 'core/components/label';

import useStyles from './policy-comments-banner.styles';

/**
 * Surfaces a migrated farm policy's source "COMMENTS OR RESTRICTIONS" comments as an informational
 * banner — distinct from the orange PolicyRestrictionsBanner. The source dec's comments are
 * informational migration notes (prior policy numbers, quote numbers, discount-program references,
 * workflow notes like "UPDATED LIABILITY TO BRANCH"), NOT coverage restrictions. #33009 deliberately
 * stopped migrating them into global.farmVerification.restrictions (which drives the alert banner and
 * the editable Details restriction box) because they fabricated a restriction on every policy — they
 * are archived on importedData.conversionMetadata.sourceComments instead.
 *
 * Comments and restrictions are separate concerns, so this banner renders independently of the
 * restriction field: a policy with only comments (and no restriction) still shows them. #33297
 */
const PolicyCommentsBanner = ({ policy }) => {
  const classes = useStyles();

  if (!isFarmBasedPolicyType(policy?.policyType)) {
    return null;
  }
  const comments = policy?.importedData?.conversionMetadata?.sourceComments?.trim();
  if (!comments) {
    return null;
  }

  return (
    <Banner color="greenLight" show iconType="check">
      <Label type="smallWhite" className={classes.text}>
        <strong>Policy comments:</strong> {comments}
      </Label>
    </Banner>
  );
};

PolicyCommentsBanner.propTypes = {
  policy: PropTypes.shape({
    policyType: PropTypes.string,
    importedData: PropTypes.shape({
      conversionMetadata: PropTypes.shape({
        sourceComments: PropTypes.string
      })
    })
  })
};

PolicyCommentsBanner.defaultProps = {
  policy: undefined
};

export default PolicyCommentsBanner;
